import { useQueryState } from 'nuqs';
import { searchParams } from '@/lib/searchparams';
import { useCallback, useMemo } from 'react';

export function useCategoryDataFilters() {
  const [searchQuery, setSearchQuery] = useQueryState(
    'q',
    searchParams.q
  );

  const [sort, setSort] = useQueryState(
    'sort',
    searchParams.sort
  );

  const [page, setPage] = useQueryState(
    'page',
    searchParams.page
  );

  const resetFilters = useCallback(() => {
    setSearchQuery(null);
    setSort(null);
    setPage(1);
  }, [setSearchQuery, setSort, setPage]);

  const isAnyFilterActive = useMemo(() => {
    return !!searchQuery || !!sort;
  }, [searchQuery, sort]);

  return {
    searchQuery,
    setSearchQuery,
    sort,
    setSort,
    page,
    setPage,
    resetFilters,
    isAnyFilterActive
  };
}